export var cricketTheme = {
    colors: {
        primary: "#60A630",
        secondary: "#FFCD00",
        tertiary: "#3170B7",
        quaternary: "#C4D600",
        darkGreen: "#046A38",
        red: "#CF292A",
        blue: "#12508D",
        darkerGray: "#404041",
        darkGray: "#6E6F72",
        gray: "#BBBDC0",
        lightGray: "#E1DFE1",
        lighterGray: "#F6F6F6",
        white: "#FFF",
        black: "#000",
    },
    typography: {
        bodyColor: "#000",
        fontFamily: "'Simply Cricket', 'neue-haas-grotesk-display', sans-serif",
        fontSize: "100%",
        title: {
            fontSize: 75,
            fontSizeMobile: 48,
            fontSizeTablet: 75,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading2: {
            fontSize: 60,
            fontSizeMobile: 40,
            fontSizeTablet: 48,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading3: {
            fontSize: 40,
            fontSizeMobile: 24,
            fontSizeTablet: 24,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading4: {
            fontSize: 32,
            fontSizeMobile: 24,
            fontSizeTablet: 32,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading5: {
            fontSize: 32,
            fontSizeMobile: 24,
            fontSizeTablet: 32,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        heading6: {
            fontSize: 24,
            fontSizeTablet: 24,
            fontSizeMobile: 24,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        body: {
            fontSize: 16,
            fontSizeMobile: 16,
            fontSizeTablet: 16,
            lineHeight: "1.5",
            fontWeight: "normal",
        },
    },
};
